import React from "react";
import { Pagination, Responsive } from "semantic-ui-react"
import { calculatePages } from "../../Helper"

function PaginationComponent(props) {
  const { itemArray, pageNum, onPageNumChange, itemsPerPage, totalPage } = props;

  const totalPages = calculatePages(itemArray, itemsPerPage) // itemsPerPage not required, defaults to 10

  return (
    <div className="row bookings-bottom pb-0 justify-content-center">
      <div className="col-lg-6  col-md-12 bookings-bottom-pagination">
        <Responsive minWidth={1200}>
          <Pagination
            totalPages={
              totalPage !== undefined ? totalPage : totalPages.length > 0 ? totalPages.length : 1
            }
            siblingRange={1}
            boundaryRange={1}
            // ellipsisItem={null}
            firstItem={false}
            lastItem={false}
            onPageChange={(e) => onPageNumChange(e)}
            activePage={pageNum}
          />
        </Responsive>
        <Responsive maxWidth={1199}>
          <Pagination
            totalPages={
              totalPages.length > 0 ? totalPages.length : 1
            }
            ellipsisItem={false}
            firstItem={false}
            lastItem={false}
            boundaryRange={0}
            siblingRange={0}
            onPageChange={(e) => onPageNumChange(e)}
            activePage={pageNum}
          />
        </Responsive>
      </div>
    </div>
  )
}

export default PaginationComponent;